import userState from '../state/user';
import { SET_USER } from '../actions/user';

export default (state = userState, action) => {
  switch (action.type) {
    case SET_USER:
      return Object.assign({}, state, action.payload);
    default: return state;
  }
};
